import api from "../configurations/http-common";

const autorize = (data) => {
  return api.unsecuredAxios().post("/web/user/authorize", data);
};

const sentOtp = (phone) => {
  return api.unsecuredAxios().post("/web/user/login/" + phone);
};
const verifyOtp = (phone) => {
  return api
    .unsecuredAxios()
    .post("/web/user/authorize/" + phone.phone + "/verify/" + phone.otp);
};

const forgotPassword = async (userName) => {
  return api
    .securedAxios()
    .get("/web/user/forgot_password?emailId=" + userName);
};

const getUserDetails = (userIdOrEmailOrPhone, loadProfileImage) => {
  return api
    .securedAxios()
    .get(
      "web/user?loadProfileImage=" +
        loadProfileImage +
        "&userIdOrEmailOrPhone=" +
        userIdOrEmailOrPhone,
    );
};
const updatePassword = (userName, payload) => {
  return api
    .securedAxios()
    .put("web/user/change_password/" + userName, payload);
};
const logout = () => {
  return api.securedAxios().get("web/user/revoke");
};

const updateUser = (userIdOrEmailOrPhone, payload) => {
  return api
    .securedAxios()
    .put("web/user?userIdOrEmailOrPhone=" + userIdOrEmailOrPhone, payload);
};

const tokenRefresh = (payload) => {
  return api.unsecuredAxios().put("/web/user/refresh_token", payload);
};

export const resetPassword = async (request) => {
  return api.unsecuredAxios().put("/web/user/reset_password", request);
};

const UserService = {
  autorize,
  sentOtp,
  verifyOtp,
  forgotPassword,
  resetPassword,
  getUserDetails,
  updatePassword,
  logout,
  updateUser,
  tokenRefresh,
  resetPassword,
};

export default UserService;
